import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { MotifIcon, MotifButton } from "@ey-xd/motif-react";
import { IconoirCheck } from "@ey-xd/motif-icon";
import "./ConsumptionSummary.scss";
import ConsumptionTable from "../ConsumptionTable/ConsumptionTable";

const ConsumptionSummary = ({
	transactionListData,
}: {
	transactionListData: any[];
}) => {
	const [summaryDataList, setSummaryDataList] = useState(transactionListData);
	const navigate = useNavigate();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		if (transactionListData?.length > 0) {
			const newConsumptionListData = transactionListData.map(
				(product: any) => ({
					...product,
					isExpanded: true,
					SkuDetails: product.SkuDetails.map((sku: any) => ({
						...sku,
						isExpanded: true,
						Transactions: sku.Transactions.map((txn: any) => ({
							...txn,
						})),
					})),
				})
			);
			setSummaryDataList(newConsumptionListData);
		}
	}, [transactionListData, setSummaryDataList]);

	return (
		<div className="consumption-summary-wrapper">
			<section className="summary-content-header">
				<div className="success-grid-section">
					<div className="success-grid-icon">
						<MotifIcon
							iconFunction={IconoirCheck}
							size="md"
							fill="#fff"
							strokeWidth="5px"
						/>
					</div>
					<div>
						<div className="success-grid-transaction-title">
							Transaction(s) successfully processed!
						</div>
						<div className="success-grid-transaction-description">
							Your transaction(s) have been successfully processed and will be
							prepared for transmission to the Billing Hub.
						</div>
					</div>
				</div>
			</section>
			<section className="summary-content-body">
				<ConsumptionTable
					consumptionListData={summaryDataList}
					setConsumptionListData={setSummaryDataList}
					isSummary={true}
					activeTab={0}
				/>
				<div className="process-transaction-btn-wrapper">
					<MotifButton
						type="button"
						onClick={() => {
							navigate("/");
						}}
					>
						Back To Homepage
					</MotifButton>
				</div>
			</section>
		</div>
	);
};

export default ConsumptionSummary;
